export const normalizeWhiteSpaces = (str: string): string => {
  return str.replace(/\s+/g, ' ');
};
